import { useNavigate } from 'react-router-dom';

export default function ProductLineup() {
  const navigate = useNavigate();

  const handleViewDetail = (model: string) => {
    navigate(`/product/${model}`);
    window.scrollTo(0, 0);
  };

  return (
    <section id="products" className="py-24 bg-[#fafafa]">
      <div className="max-w-6xl mx-auto px-6">
        {/* Heading */}
        <h2 className="text-4xl font-bold text-center mb-6 leading-tight text-[#1a1a2e]">
          全社員に同じオフィスチェアは、<br />
          必ずしも最適解ではありません。
        </h2>
        <p className="text-center text-lg mb-12 text-[#4a4a4a]">
          MeVERは「役割」に合わせて選ぶ、3モデル構成。
        </p>

        {/* Product Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {/* Core Card */}
          <div className="bg-[#5a5a6e] rounded-2xl p-8 text-white flex flex-col">
            <h3 className="text-2xl font-bold mb-4">MeVER Chair Core v1.0</h3>
            <p className="text-sm mb-4 text-white/80">一般企業オフィス / バックオフィス / 標準デスクワーク</p>
            <div className="w-full h-64 bg-white/10 rounded-lg mb-4 overflow-hidden">
              <img
                src="https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/f4a7d90296f789d46c6753357c7a51a3.png"
                alt="MeVER Chair Core"
                className="w-full h-full object-contain object-center"
              />
            </div>
            <div className="mb-4">
              <div className="text-3xl font-bold">¥79,200</div>
              <div className="text-xs text-white/70 mt-1">税込・送料別</div>
              <a
                href="#contact-form"
                onClick={(e) => { e.preventDefault(); document.getElementById('contact-form')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-1.5 mt-2 px-3 py-1.5 bg-amber-400 text-[#1a1a2e] text-xs font-bold rounded-full hover:bg-amber-300 transition-all cursor-pointer"
              >
                <i className="ri-building-2-line"></i>
                <span>法人様 特別価格あり</span>
                <i className="ri-arrow-right-s-line"></i>
              </a>
            </div>
            <ul className="space-y-2 text-sm mb-6">
              <li className="flex items-center space-x-2">
                <i className="ri-check-line"></i>
                <span>一般企業にちょうど良いルックス</span>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-check-line"></i>
                <span>高機能をリーズナブルに</span>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-check-line"></i>
                <span>4Dアームレスト搭載/3Dヘッドレストオプション対応可</span>
              </li>
            </ul>
            <div className="mt-auto">
              <button
                onClick={() => handleViewDetail('core')}
                className="w-full py-3 rounded-full bg-white text-[#5a5a6e] text-sm font-bold hover:bg-white/90 transition-all inline-flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <span>製品詳細を見る</span>
                <i className="ri-arrow-right-line text-base"></i>
              </button>
            </div>
          </div>

          {/* Pro Card */}
          <div className="bg-[#8E7CC3] rounded-2xl p-8 text-white flex flex-col">
            <h3 className="text-2xl font-bold mb-4">MeVER Chair Pro v2.0</h3>
            <p className="text-sm mb-4 text-white/80">クリエイター / エンジニア / ビジネスマン / 電動昇降デスクユーザー / ミュージシャン</p>
            <div className="w-full h-64 bg-white/10 rounded-lg mb-4 overflow-hidden">
              <img
                src="https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/18555a65f21397adfed78720e8be08d7.png"
                alt="MeVER Chair Pro"
                className="w-full h-full object-contain object-center"
              />
            </div>
            <div className="mb-4">
              <div className="text-3xl font-bold">¥123,200</div>
              <div className="text-xs text-white/70 mt-1">税込・送料別</div>
              <a
                href="#contact-form"
                onClick={(e) => { e.preventDefault(); document.getElementById('contact-form')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-1.5 mt-2 px-3 py-1.5 bg-amber-400 text-[#1a1a2e] text-xs font-bold rounded-full hover:bg-amber-300 transition-all cursor-pointer"
              >
                <i className="ri-building-2-line"></i>
                <span>法人様 特別価格あり</span>
                <i className="ri-arrow-right-s-line"></i>
              </a>
            </div>
            <ul className="space-y-2 text-sm mb-6">
              <li className="flex items-center space-x-2">
                <i className="ri-check-line"></i>
                <span>6Dアームレスト/3Dヘッドレスト搭載</span>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-check-line"></i>
                <span>電動昇降デスクとの相性抜群</span>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-check-line"></i>
                <span>クオリティを妥協しないデザイン</span>
              </li>
            </ul>
            <div className="mt-auto">
              <button
                onClick={() => handleViewDetail('pro')}
                className="w-full py-3 rounded-full bg-white text-[#8E7CC3] text-sm font-bold hover:bg-white/90 transition-all inline-flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <span>製品詳細を見る</span>
                <i className="ri-arrow-right-line text-base"></i>
              </button>
            </div>
          </div>

          {/* Style Card */}
          <div className="bg-[#5a8a6a] rounded-2xl p-8 text-white flex flex-col">
            <h3 className="text-2xl font-bold mb-4">MeVER Chair Style v1.0</h3>
            <p className="text-sm mb-4 text-white/80">健康志向ユーザー / ウェルネス重視 / バランスボール愛用者</p>
            <div className="w-full h-64 bg-white/10 rounded-lg mb-4 overflow-hidden">
              <img
                src="https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/0e5886a34ba8b9935f350bf408063f8e.png"
                alt="MeVER Chair Style"
                className="w-full h-full object-contain object-center"
              />
            </div>
            <div className="mb-4">
              <div className="text-3xl font-bold">¥69,300</div>
              <div className="text-xs text-white/70 mt-1">税込・送料別</div>
              <a
                href="#contact-form"
                onClick={(e) => { e.preventDefault(); document.getElementById('contact-form')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-1.5 mt-2 px-3 py-1.5 bg-amber-400 text-[#1a1a2e] text-xs font-bold rounded-full hover:bg-amber-300 transition-all cursor-pointer"
              >
                <i className="ri-building-2-line"></i>
                <span>法人様 特別価格あり</span>
                <i className="ri-arrow-right-s-line"></i>
              </a>
            </div>
            <ul className="space-y-2 text-sm mb-6">
              <li className="flex items-center space-x-2">
                <i className="ri-check-line"></i>
                <span>バランスボール代替品</span>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-check-line"></i>
                <span>体幹刺激座面設計</span>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-check-line"></i>
                <span>健康志向ユーザー向け</span>
              </li>
            </ul>
            <div className="mt-auto">
              <button
                onClick={() => handleViewDetail('style')}
                className="w-full py-3 rounded-full bg-white text-[#5a8a6a] text-sm font-bold hover:bg-white/90 transition-all inline-flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <span>製品詳細を見る</span>
                <i className="ri-arrow-right-line text-base"></i>
              </button>
            </div>
          </div>
        </div>

        <p className="text-center text-sm text-[#4a4a4a] mb-16">
          → フロア・部署単位での混在導入が可能です。
        </p>

        {/* Comparison Table */}
        <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-[#1a1a2e] text-white">
                  <th className="px-6 py-4 text-left text-sm font-bold">項目</th>
                  <th className="px-6 py-4 text-left text-sm font-bold border-l-4 border-[#5a5a6e]">MeVER Chair Core</th>
                  <th className="px-6 py-4 text-left text-sm font-bold border-l-4 border-[#8E7CC3]">MeVER Chair Pro</th>
                  <th className="px-6 py-4 text-left text-sm font-bold border-l-4 border-[#5a8a6a]">MeVER Chair Style</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-[#e8e6e3]">
                  <td className="px-6 py-4 text-sm font-medium text-[#1a1a2e]">想定ユーザー</td>
                  <td className="px-6 py-4 text-sm text-[#4a4a4a] border-l-4 border-[#5a5a6e]/20">一般企業オフィス / バックオフィス / 標準デスクワーク</td>
                  <td className="px-6 py-4 text-sm text-[#4a4a4a] border-l-4 border-[#8E7CC3]/20">クリエイター / エンジニア / ビジネスマン / 電動昇降デスクユーザー / ミュージシャン</td>
                  <td className="px-6 py-4 text-sm text-[#4a4a4a] border-l-4 border-[#5a8a6a]/20">健康志向ユーザー / ウェルネス重視 / バランスボール愛用者</td>
                </tr>
                <tr className="bg-[#fafafa] border-b border-[#e8e6e3]">
                  <td className="px-6 py-4 text-sm font-medium text-[#1a1a2e]">主な目的</td>
                  <td className="px-6 py-4 text-sm text-[#4a4a4a] border-l-4 border-[#5a5a6e]/20">高機能をリーズナブルに・標準業務の快適性向上</td>
                  <td className="px-6 py-4 text-sm text-[#4a4a4a] border-l-4 border-[#8E7CC3]/20">パフォーマンス最大化・電動昇降デスク最適化</td>
                  <td className="px-6 py-4 text-sm text-[#4a4a4a] border-l-4 border-[#5a8a6a]/20">体幹刺激・ウェルビーイング向上</td>
                </tr>
                <tr className="border-b border-[#e8e6e3]">
                  <td className="px-6 py-4 text-sm font-medium text-[#1a1a2e]">コア設計思想</td>
                  <td className="px-6 py-4 text-sm text-[#4a4a4a] border-l-4 border-[#5a5a6e]/20">ちょうど良いルックスと機能性のバランス</td>
                  <td className="px-6 py-4 text-sm text-[#4a4a4a] border-l-4 border-[#8E7CC3]/20">長時間・高集中でも疲労を最小化</td>
                  <td className="px-6 py-4 text-sm text-[#4a4a4a] border-l-4 border-[#5a8a6a]/20">無意識でも正しい姿勢を保つ</td>
                </tr>
                <tr className="bg-[#fafafa] border-b border-[#e8e6e3]">
                  <td className="px-6 py-4 text-sm font-medium text-[#1a1a2e]">主な特長</td>
                  <td className="px-6 py-4 text-sm text-[#4a4a4a] border-l-4 border-[#5a5a6e]/20">標準アームレスト / 快適メッシュバック / コストパフォーマンス</td>
                  <td className="px-6 py-4 text-sm text-[#4a4a4a] border-l-4 border-[#8E7CC3]/20">6Dアームレスト / 高剛性フレーム / 電動昇降デスク対応</td>
                  <td className="px-6 py-4 text-sm text-[#4a4a4a] border-l-4 border-[#5a8a6a]/20">体幹刺激座面 / バランスボール効果 / ナチュラルフィット</td>
                </tr>
                <tr className="border-b border-[#e8e6e3]">
                  <td className="px-6 py-4 text-sm font-medium text-[#1a1a2e]">使用シーン</td>
                  <td className="px-6 py-4 text-sm text-[#4a4a4a] border-l-4 border-[#5a5a6e]/20">日常業務 / 一般的なオフィスワーク</td>
                  <td className="px-6 py-4 text-sm text-[#4a4a4a] border-l-4 border-[#8E7CC3]/20">長時間作業 / クリエイティブワーク / 電動昇降デスク環境</td>
                  <td className="px-6 py-4 text-sm text-[#4a4a4a] border-l-4 border-[#5a8a6a]/20">健康重視の日常業務 / 短〜中時間作業</td>
                </tr>
                <tr className="bg-[#f5f0ff]">
                  <td className="px-6 py-4 text-sm font-medium text-[#1a1a2e]">導入実績</td>
                  <td className="px-6 py-4 text-sm text-[#4a4a4a] border-l-4 border-[#5a5a6e]/20">一般企業オフィス<br />コストパフォーマンス重視の導入</td>
                  <td className="px-6 py-4 text-sm text-[#4a4a4a] border-l-4 border-[#8E7CC3]/20">在日米軍基地（メイン導入）<br />会議室用途でStyleも併用</td>
                  <td className="px-6 py-4 text-sm text-[#4a4a4a] border-l-4 border-[#5a8a6a]/20">favy新宿（メイン導入）<br />集中・プレミアム用途でPro併用</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <p className="text-center text-sm text-[#4a4a4a] mt-8">
          3モデルとも実運用環境での導入実績があり、役割・空間・利用者特性に応じた組み合わせ導入が可能です。
        </p>

        <div className="text-center mt-8">
          <a
            href="/compare"
            className="inline-flex items-center gap-2 bg-[#1a1a2e] text-white px-8 py-3.5 rounded-full text-sm font-bold hover:bg-[#2a2a3e] transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-scales-3-line text-lg"></i>
            <span>3モデルを詳しく比較する</span>
            <i className="ri-arrow-right-line text-lg"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
